import createYCloudIcon from '../createYCloudIcon';

/**
 * @component @name EthernetPort
 * @description YCloud SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgOHYxIiAvPgogIDxwYXRoIGQ9Ik0xNCA4djEiIC8+CiAgPHBhdGggZD0iTTE4IDh2MSIgLz4KICA8cGF0aAogICAgZD0iTTE5IDE3YTIgMiAwIDAgMC0xLjc2NSAxLjA1OWwtLjQ3Ljg4MkEyIDIgMCAwIDEgMTUgMjBIOWEyIDIgMCAwIDEtMS43NjUtMS4wNTlsLS40Ny0uODgyQTIgMiAwIDAgMCA1IDE3SDRhMiAyIDAgMCAxLTItMlY2YTIgMiAwIDAgMSAyLTJoMTZhMiAyIDAgMCAxIDIgMnY5YTIgMiAwIDAgMS0yIDJ6IgogIC8+CiAgPHBhdGggZD0iTTYgOHYxIiAvPgo8L3N2Zz4K) - https://tianjianjun0727.github.io/ycloud-icons/icons/ethernet-port
 * @see https://tianjianjun0727.github.io/ycloud-icons/guide/preact - Documentation
 *
 * @param {Object} props - YCloud icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EthernetPort = createYCloudIcon('ethernet-port', [
  ['path', { d: 'M10 8v1', key: '1talb4' }],
  ['path', { d: 'M14 8v1', key: '1rsfgr' }],
  ['path', { d: 'M18 8v1', key: 'gnkwox' }],
  [
    'path',
    {
      d: 'M19 17a2 2 0 0 0-1.765 1.059l-.47.882A2 2 0 0 1 15 20H9a2 2 0 0 1-1.765-1.059l-.47-.882A2 2 0 0 0 5 17H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2z',
      key: '192n2p',
    },
  ],
  ['path', { d: 'M6 8v1', key: '1636ez' }],
]);

export default EthernetPort;
